
import Vue from 'vue'
import ContextMenu from '@/components/navigation/ContextMenu.vue'
import RIcon from '@/components/icons/index.vue'

export default Vue.extend({
  name: 'DriveCardContextMenu',
  components: {
    ContextMenu,
    RIcon,
  },
  props: {
    canAssign: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: '',
    },
  },
})
